// Old invitation links remain valid, including after sign-in.
import { createFileRoute, redirect } from "@tanstack/react-router";
import { requireSignedIn } from "../auth/requireSignedIn";
import { validateInvitesSearch } from "../routeState/sectionSearch";
export const Route = createFileRoute("/invites")({
  validateSearch: validateInvitesSearch,
  beforeLoad: (opts) => {
    requireSignedIn(opts);
    // oxlint-disable-next-line typescript/only-throw-error
    throw redirect({
      to: "/pools/invitations",
      search: opts.search,
      replace: true,
    });
  },
});
